<template>
  <i class="tm-audio-shadow-span" :style="styleObj">
    <i v-if="showBanner" class="-banner">Insert</i>
  </i>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'tm-audio-shadow-span',

  props: {
    track: { type: Object, required: true },
    rectangle: { type: Object, required: true },
    isFirst: { type: Boolean, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      pxAudioTopOffset: (state) => state.cssVariables.pxAudioTopOffset,
      pxAudioTrackH: (state) => state.cssVariables.pxAudioTrackH,
    }),

    styleObj() {
      return {
        transform: `translate3d(${this.$props.rectangle.p1.x}px, ${
          this.$props.rectangle.p1.y + this.pxAudioTopOffset
        }px, 0)`,
        width: `${this.$props.rectangle.width}px`,
      };
    },

    showBanner() {
      return this.$props.isFirst && this.$props.rectangle.width > 40;
    },
  },
};
</script>

<style lang="scss">
.tm-audio-shadow > .tm-audio-shadow-span {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  height: var(--tm-pxAudioTrackH);
  overflow: hidden;

  > .-banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    color: #fff;
    font-size: 16px;
    font-weight: 400;
    text-shadow: 0 1px 3px #000;
  }
}
</style>
